export default "__VITE_ASSET__BhdI3gaN__"